export const ListQueryKey = 'ActivityRoom';
export const DetailQueryKey = 'activityRecommendRecord';
export const Urls = {
  selectUrl: '/Room/list',
  updateUrl: '/Room/update',
  deleteUrl: '/Room/delete',
  createUrl: '/Room/create',
  detailUrl: '/Room/info'
}; // /api/ZlQyRecord/list